import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { dropDownListApi } from '../api.service';

export interface DropDownItem {
    label: string;
    value: string;
    docType: string | null | undefined;
    code?: string;
    color?: string;
    avatar?: string;
}

export const useDropDownList = (
    docType: string,
    params?: string
): UseQueryResult<{ data: DropDownItem[]; metadata: { formName: string } }> => {
    return useQuery<{ data: DropDownItem[]; metadata: { formName: string } }>({
        queryKey: ['dropDownList', docType, params],
        queryFn: async () => {
            const response = await dropDownListApi(docType, params);
            return {
                data: response.data as DropDownItem[],
                metadata: response.metadata as { formName: string },
            };
        },  
        initialData: { data: [], metadata: { formName: '' } },
        enabled: !!docType,
        retry: 1,
    });
};



